import { render, staticRenderFns } from "./AboutDetail.vue?vue&type=template&id=a62dac20&scoped=true&"
import script from "./AboutDetail.vue?vue&type=script&lang=js&"
export * from "./AboutDetail.vue?vue&type=script&lang=js&"
import style0 from "./AboutDetail.vue?vue&type=style&index=0&id=a62dac20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62dac20",
  null
  
)

export default component.exports